export * from './simple-layout.component';



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/containers/simple-layout/index.ts